import { make } from 'vuex-pathify';
import { filter, keyBy, keys, shuffle, sortBy, values } from 'lodash';

const riskLevels = keyBy(
    [
        {
            id: 1,
            title: 'Higher risk',
            text:
                'involves body parts and body fluids that carry a high risk of HIV transmission when a condom or when PrEP is not used (like rectal tissue in your butt or blood). Higher risk also includes engaging in sexual acts with a partner living with HIV whose viral load is not suppressed, when body fluids are exchanged and neither a condom or PrEP are used.',
            value: 'high',
            image: require('@/assets/buckets/higherrisk.png'),
            visited: false
        },
        {
            id: 2,
            title: 'Medium risk',
            text:
                'involves either body parts that carry a medium risk of HIV transmission when a condom is not used (like vaginal tissue) or medium risk when a condom is used (like rectal tissue in your butt).',
            value: 'medium',
            image: require('@/assets/buckets/mediumrisk.png'),
            visited: false
        },
        {
            id: 3,
            title: 'Lower risk',
            text:
                'involves body parts that carry a low risk of HIV transmission (like oral tissue) or involve body parts with higher risk of transmission (like rectal tissue in your butt) with risk reduced by use of PrEP (by HIV-negative partners) or viral suppression (of partners living with HIV).',
            value: 'low',
            image: require('@/assets/buckets/lowrisk.png'),
            visited: false
        },
        {
            id: 4,
            title: 'No risk',
            text: 'involves body parts or body fluids that don’t carry risk of HIV transmission (like those that don’t involve a penis or vagina!)',
            value: 'no',
            image: require('@/assets/buckets/norisk.png'),
            visited: false
        }
    ],
    'id'
);
const riskLevelsOrder = sortBy(keys(riskLevels), k => parseInt(k));

const riskActivities = keyBy(
    [
        {
            id: 1,
            text: 'Anal bottoming or receptive fucking (no condom, no PrEP, no viral suppression)',
            correctAnswer: 'high',
            answered: false
        },
        {
            id: 2,
            text: 'Anal bottoming or receptive fucking (no condom, HIV-negative parter(s) on PrEP)',
            correctAnswer: 'low',
            answered: false
        },
        {
            id: 3,
            text: 'Anal topping or insertive fucking (no condom, no PrEP, no viral suppression)',
            correctAnswer: 'high',
            answered: false
        },
        {
            id: 4,
            text: 'Anal topping or insertive fucking (no condom, HIV-negative parter(s) on PrEP)',
            correctAnswer: 'low',
            answered: false
        },
        {
            id: 5,
            text: 'Ass fucking with a condom and lube (no PrEP, no viral suppression)',
            correctAnswer: 'medium',
            answered: false
        },
        {
            id: 6,
            text: 'Giving head (no condom, no swallowing)',
            correctAnswer: 'low',
            answered: false
        },
        {
            id: 7,
            text: 'Rimming (no dental dam, no blood)',
            correctAnswer: 'no',
            definition: 'The act of using one’s tongue on the anus (butt) of another person.',
            answered: false
        },
        {
            id: 8,
            text: 'Insertive sex with a vagina or front hole (no condom, no PrEP, no viral suppression)',
            correctAnswer: 'medium',
            answered: false
        },
        {
            id: 9,
            text: 'Hand job (Giving or Receiving)',
            correctAnswer: 'no',
            answered: false
        },
        {
            id: 10,
            text: 'Mutual masturbation',
            correctAnswer: 'no',
            answered: false
        },
        {
            id: 11,
            text: '69 (no condom)',
            correctAnswer: 'low',
            definition:
                'The act of two people performing oral sex on each other at the same time. It’s called “69” because the numbers 6 and 9 resemble the physical position of the two partners during this sex act.',
            answered: false
        },
        {
            id: 12,
            text: 'Water sports',
            correctAnswer: 'no',
            definition: 'Sexual activity that involves someone peeing on someone else.',
            answered: false
        },
        {
            id: 13,
            text: 'Toe sucking',
            correctAnswer: 'no',
            answered: false
        },
        {
            id: 14,
            text: 'Getting tied up',
            correctAnswer: 'no',
            answered: false
        },
        {
            id: 15,
            text: 'Kissing',
            correctAnswer: 'no',
            answered: false
        },
        {
            id: 16,
            text: 'Cuddling',
            correctAnswer: 'no',
            answered: false
        },
        {
            id: 17,
            text: 'Dry humping',
            correctAnswer: 'no',
            answered: false
        },
        {
            id: 18,
            text: 'Sucking titties (no breast milk)',
            correctAnswer: 'no',
            answered: false
        },
        {
            id: 19,
            text: 'Tittie fucking (no ejaculation/cum)',
            correctAnswer: 'no',
            answered: false
        },
        {
            id: 20,
            text: 'Eating pussy',
            correctAnswer: 'low',
            answered: false
        },
        {
            id: 21,
            text: 'Spanking',
            correctAnswer: 'no',
            answered: false
        }
    ],
    'id'
);
const riskActivitiesSorted = sortBy(values(riskActivities), [
    value => {
        switch (value) {
            case 'high':
                return 1;
            case 'medium':
                return 2;
            case 'low':
                return 3;
            case 'no':
                return 4;
            default:
                return 0;
        }
    },
    'id'
]);

const assSexStrategies = keyBy(
    [
        {
            id: 1,
            strategy: 'Use a condom',
            text: '<span class="font-weight-bold">Great!</span> Using a condom is a great way to reduce the risk of HIV as well as other STIs and pregnancy.',
            correct: true,
            picked: false
        },
        {
            id: 2,
            strategy: 'Pull out before cumming',
            text:
                '<span class="font-weight-bold">Nope.</span> The pull out method - withdrawing the penis before ejaculation- doesn’t prevent HIV because pre-cum and vaginal/anal fluids can contain the virus too.',
            correct: false,
            picked: false
        },
        {
            id: 3,
            strategy: 'Taking PrEP daily',
            text:
                '<span class="font-weight-bold">Yes!</span> Using PrEP and having a partner on PrEP is a great way to significantly reduce the chance of getting or passing HIV. In fact, taking PrEP as prescribed can reduce the chance of getting HIV by about 99%.',
            correct: true,
            picked: false
        },
        {
            id: 4,
            strategy: 'Using lube',
            text:
                '<span class="font-weight-bold">No.</span> Lube alone does not help prevent HIV. However, using lube with condoms can help prevent condoms from breaking and slipping. Remember to only use water-based and silicone-based lube with condoms. <span class="font-weight-bold">NEVER</span> use oil-based lubes or products that contain oil (e.g., hand lotion, Vaseline, Crisco) with external condoms because they can cause a condom to break.',
            correct: false,
            picked: false
        },
        {
            id: 5,
            strategy: 'Getting tested regularly',
            text:
                '<span class="font-weight-bold">Not totally.</span> While getting tested regularly is important and can help prevent the transmission of HIV and other STIs, it doesn’t directly prevent HIV.',
            correct: false,
            picked: false
        },
        {
            id: 6,
            strategy: 'Cleaning out or douching before anal sex',
            text:
                '<span class="font-weight-bold">Try again!</span> Cleaning out or douching before anal sex can actually put you at higher risk of HIV since it removes the mucous lining – leaving you at higher risk when condoms or PrEP aren’t used. Also, using a douche with a nozzle can cause tiny cuts.',
            correct: false,
            picked: false
        },
        {
            id: 7,
            strategy: 'Choose a different way to have sex and/or experience pleasure',
            text:
                '<span class="font-weight-bold">Totally!</span> Anal sex is the highest-risk sexual activity for HIV transmission so selecting a different way to engage in sex (e.g., blow jobs) or pleasure (e.g., getting tied up, sensual massage) is a great option to reduce your risk of getting or passing HIV.',
            correct: true,
            picked: false
        }
    ],
    'id'
);

const state = {
    title: 'Bucket List!',
    complete: false,
    sticker: {
        text: 'Bucket with 10',
        earned: false,
        image: require('@/assets/stickers/stickers_0001_bucket.png')
    },
    bonusSticker: false,
    trophy: false,
    riskLevels,
    riskLevelsOrder,
    riskActivities,
    riskActivitiesSorted,
    assSexStrategies
};
const getters = {
    ...make.getters(state),
    allRiskLevelsVisited: state => {
        return 0 === filter(values(state.riskLevels), { visited: false }).length;
    },
    currentRiskActivity: state => {
        const remaining = shuffle(filter(values(state.riskActivities), { answered: false })); // shuffle the remaining unanswered activities
        if (remaining && remaining.length) {
            return state.riskActivities[remaining[0].id]; // pick from the top of the shuffled remaining pile
        }
        return null;
    }
};
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
